import React, { Component } from 'react'
import './Hero.scss'

export default class HeroCard extends Component {

    state = {
        proprety : "",
        properties : "",
    }





    render() {

        const {vote_count, poster_path, backdrop_path, original_title, genre_ids, vote_average, overview, release_date} = this.state.properties;

        return (
            <div className = "heroCard">
                <div className="cardWraper">
                    <div className="postWraper" >
                        <div className="poster" style={{backgroundImage : `url("http://image.tmdb.org/t/p/w500/${poster_path}")`}} ></div>
                        <img src="" alt=""/>
                        <button><span className="fas fa-ticket-alt"></span> Book now</button>

                    </div>
                    <div className="detailsWraper">
                        <h1 className="movieName">
                            {original_title}
                        </h1>
                        <div className = "rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>

                            {vote_count} votes

                        </div>
                        <p className="movieDescription">
                            {overview}
                        </p>
                        <div className="castWraper">
                            <h2 className="castTitle">
                                Cast:
                            </h2>
                            <div className="cast">
                                <div className="image"></div>
                                <div className="image"></div>
                                <div className="image"></div>
                                <div className="image"></div>
                                <div className="image"></div>
                            </div>
                        </div>
                        <div className="trailer">
                            <h2>Watch Trailer</h2>
                            <button>
                                <span className="fas fa-play-circle"></span>
                                Play Now
                            </button>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }

    componentDidMount() {
        const key = "21f53417a5404d2ee865b5d4641ec478"
        const queryValue = `https://api.themoviedb.org/3/movie/popular?api_key=${key}&language=en-US&page=1`

        const query = fetch(queryValue)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    proprety : data.results,
                    properties : data.results[0],
                })
            });
    }

}
